import styles from './AboutUsTextBlock.scss';

export default function AboutUsTextBlock(data) {
  return (
    <div className={'container about-us-text-block'}>
      <div className={'purpose'} data-aos="fade-up">
        {data?.fields?.title?.value && (
          <span className={'purpose_headline'}>{data.fields.title.value}</span>
        )}
        <p
          className={'purpose_description'}
          dangerouslySetInnerHTML={{ __html: data.fields.text.value }}
        />
      </div>
    </div>
  );
}
